import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.j4b_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.k4b_1 = LinkedHashMap().ec();
      }
      l4b() {
        return this.k4b_1;
      }
      n42() {
        // Inline function 'kotlin.apply' call
        this.j4b_1.n42();
        return this;
      }
      o42() {
        // Inline function 'kotlin.apply' call
        this.j4b_1.o42();
        return this;
      }
      f42() {
        // Inline function 'kotlin.apply' call
        this.j4b_1.f42();
        return this;
      }
      g42() {
        // Inline function 'kotlin.apply' call
        this.j4b_1.g42();
        return this;
      }
      k4e(name) {
        // Inline function 'kotlin.apply' call
        this.j4b_1.k4e(name);
        return this;
      }
      u42(value) {
        // Inline function 'kotlin.apply' call
        this.j4b_1.u42(value);
        return this;
      }
      e43(value) {
        // Inline function 'kotlin.apply' call
        this.j4b_1.e43(value);
        return this;
      }
      z42(value) {
        // Inline function 'kotlin.apply' call
        this.j4b_1.z42(value);
        return this;
      }
      w42(value) {
        // Inline function 'kotlin.apply' call
        this.j4b_1.w42(value);
        return this;
      }
      c43(value) {
        // Inline function 'kotlin.apply' call
        this.j4b_1.c43(value);
        return this;
      }
      m4e(value) {
        // Inline function 'kotlin.apply' call
        this.j4b_1.m4e(value);
        return this;
      }
      j43(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.k4b_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.j4b_1.a4e();
        tmp0.x4(key, value);
        this.j4b_1.y41();
        return this;
      }
      y41() {
        // Inline function 'kotlin.apply' call
        this.j4b_1.y41();
        return this;
      }
      a4e() {
        return this.j4b_1.a4e();
      }
      l6() {
        this.j4b_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
